/**
 * Segmented — a small token-styled segmented control (currency / billing
 * frequency toggles on the pricing blocks). Shared by PricingTiers and
 * PricingTierDetail so the control looks identical across the page.
 */
import { cn } from '../../utils';

export interface SegmentedProps<T extends string> {
  readonly value: T;
  readonly options: readonly { readonly v: T; readonly label: string }[];
  readonly onChange: (v: T) => void;
  readonly className?: string;
}

export function Segmented<T extends string>({ value, options, onChange, className }: SegmentedProps<T>) {
  return (
    <div className={cn('inline-flex gap-1 rounded-md border border-border bg-card p-1', className)}>
      {options.map((o) => (
        <button
          key={o.v}
          type="button"
          onClick={() => onChange(o.v)}
          className={cn(
            'rounded px-3 py-1 text-sm font-medium transition-colors',
            value === o.v ? 'bg-primary-light text-primary' : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
